import React, { useState } from 'react';
import {useDispatch} from 'react-redux';
import {NavLink, useNavigate} from 'react-router-dom';
import {logout} from "../../redux/authStore/slice";
import {Dropdown} from "../../components/Dropdown"

import { PiAirplaneTiltLight } from "react-icons/pi";
import { SlCalculator } from "react-icons/sl";
import { IoNotificationsOutline } from "react-icons/io5";
import { TfiWallet } from "react-icons/tfi";
import { LiaHandsHelpingSolid } from "react-icons/lia";

const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);

    const handleDropdownClick = (item) => {
        if (item === "Logout") {
            dispatch(logout());
            navigate("/login");
        }
    };

    return (
        <header className="bg-light border border-bottom flex-shrink-0">
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container-fluid">
                    <button
                        className="navbar-toggler"
                        type="button"
                        aria-label="Toggle navigation"
                        onClick={() => setIsOpen((v) => !v)}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`}>
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <span className="nav-link"><PiAirplaneTiltLight size={20} /></span>
                            </li>
                            <li className="nav-item">
                                <span className="nav-link"><SlCalculator size={16}/></span>
                            </li>
                            <li className="nav-item">
                                <span className="nav-link"><IoNotificationsOutline size={20}/></span>
                            </li>
                            <li className="nav-item">
                                <span className="nav-link"><TfiWallet size={18}/></span>
                            </li>
                            <li className="nav-item">
                                <span className="nav-link"><LiaHandsHelpingSolid size={20}/></span>
                            </li>
                        </ul>

                        {/* Mobile navigation (sidebar items) */}
                        <hr className="d-md-none" />
                        <ul className="navbar-nav d-md-none">
                            <li className="nav-item">
                                <NavLink
                                    to="/dashboard"
                                    end
                                    onClick={() => setIsOpen(false)}
                                    className={({ isActive }) => `nav-link ${isActive ? 'active text-primary fw-semibold' : ''}`}
                                >
                                    Dashboard
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/contact"
                                    onClick={() => setIsOpen(false)}
                                    className={({ isActive }) => `nav-link ${isActive ? 'active text-primary fw-semibold' : ''}`}
                                >
                                    Contact
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/file-store"
                                    onClick={() => setIsOpen(false)}
                                    className={({ isActive }) => `nav-link ${isActive ? 'active text-primary fw-semibold' : ''}`}
                                >
                                    File Store
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/ledger"
                                    onClick={() => setIsOpen(false)}
                                    className={({ isActive }) => `nav-link ${isActive ? 'active text-primary fw-semibold' : ''}`}
                                >
                                    Ledger
                                </NavLink>
                            </li>
                        </ul>

                        <div className="ms-auto">
                            <Dropdown
                                label="Logged in user name"
                                items={[
                                    { label: "Logout" },
                                    { label: "Another action" },
                                    { label: "Something else here" },
                                    { divider: true },
                                    { label: "Close" }
                                ]}
                                onItemClick={handleDropdownClick}
                            />
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header;
